"use client";
import React from "react";
import * as _Builtin from "./_Builtin";
import * as _interactions from "./interactions";
import * as _utils from "./utils";
import _styles from "./SponsoredListingHero.module.css";

const _interactionsData = JSON.parse(
  '{"events":{"e-303":{"id":"e-303","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-304"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"0eac6d0f-ed63-35c7-68d0-964915fb02f8","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"0eac6d0f-ed63-35c7-68d0-964915fb02f8","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":150,"direction":"BOTTOM","effectIn":true},"createdOn":1694027478964},"e-305":{"id":"e-305","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-306"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"0eac6d0f-ed63-35c7-68d0-964915fb02fb","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"0eac6d0f-ed63-35c7-68d0-964915fb02fb","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":300,"direction":"BOTTOM","effectIn":true},"createdOn":1694027478964},"e-307":{"id":"e-307","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-308"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"0eac6d0f-ed63-35c7-68d0-964915fb02fd","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"0eac6d0f-ed63-35c7-68d0-964915fb02fd","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":350,"direction":"BOTTOM","effectIn":true},"createdOn":1694027478964},"e-345":{"id":"e-345","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-346"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"bba42a2f-a462-e3e8-f83c-cd1c627d8615","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"bba42a2f-a462-e3e8-f83c-cd1c627d8615","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":400,"direction":"BOTTOM","effectIn":true},"createdOn":1696449396433}},"actionLists":{"slideInBottom":{"id":"slideInBottom","useFirstGroupAsInitialState":true,"actionItemGroups":[{"actionItems":[{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":0}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":0,"yValue":100,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":0,"yValue":0,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}},{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":1}}]}]}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
);

export function SponsoredListingHero({ as: _Component = _Builtin.Section }) {
  _interactions.useInteractions(_interactionsData, _styles);

  return (
    <_Component
      className={_utils.cx(_styles, "sponsored-listings-hero")}
      grid={{
        type: "section",
      }}
      tag="aside"
      id="SponsoredListingHero"
    >
      <_Builtin.Container
        className={_utils.cx(_styles, "homepage-hero-container")}
        tag="div"
      >
        <_Builtin.Block
          className={_utils.cx(_styles, "homepage-main-block")}
          tag="div"
        >
          <_Builtin.Block
            className={_utils.cx(_styles, "hero-block", "new")}
            tag="div"
          >
            <_Builtin.Block
              className={_utils.cx(_styles, "hero-text-block")}
              id={_utils.cx(
                _styles,
                "w-node-_0eac6d0f-ed63-35c7-68d0-964915fb02f6-15fb02f2"
              )}
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "inline-text")}
                tag="div"
              >
                <_Builtin.Heading
                  className={_utils.cx(_styles, "heading-4")}
                  data-w-id="0eac6d0f-ed63-35c7-68d0-964915fb02f8"
                  tag="h1"
                >
                  {"Supercharge your listings "}
                </_Builtin.Heading>
              </_Builtin.Block>
              <_Builtin.Block
                className={_utils.cx(_styles, "inline-text", "center")}
                tag="div"
              >
                <_Builtin.Paragraph
                  className={_utils.cx(_styles, "hero-section-paragraph")}
                  data-w-id="0eac6d0f-ed63-35c7-68d0-964915fb02fb"
                >
                  {
                    "The key to getting your listing rented? Getting in front of qualified tenants. Boost listing views, inquiries and applications with our proven advertisement solutions."
                  }
                </_Builtin.Paragraph>
              </_Builtin.Block>
              <_Builtin.Block
                className={_utils.cx(_styles, "button-block")}
                data-w-id="0eac6d0f-ed63-35c7-68d0-964915fb02fd"
                tag="div"
              >
                <_Builtin.Link
                  className={_utils.cx(_styles, "button-secondary", "ga-event")}
                  button={true}
                  id="sl-maincta-getstarted"
                  block=""
                  options={{
                    href: "/boost-a-listing?accountType=essentials",
                    preload: "none",
                  }}
                >
                  {"Get started"}
                </_Builtin.Link>
              </_Builtin.Block>
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(
                _styles,
                "home-project-demo-image-block",
                "new",
                "hero-video"
              )}
              data-w-id="bba42a2f-a462-e3e8-f83c-cd1c627d8615"
              tag="div"
            >
              <_Builtin.BlockContainer
                className={_utils.cx(_styles, "video-container")}
                grid={{
                  type: "container",
                }}
                tag="div"
              >
                <_Builtin.HtmlEmbed
                  className={_utils.cx(_styles, "video")}
                  value="%3Cvideo%20class%3D%22video%22%20autoplay%20loop%20muted%20playsinline%3E%0A%20%20%3Csource%20%0A%20%20%20%20src%3D%22https%3A%2F%2Fliv.rent%2Fblog%2Fwp-content%2Fuploads%2F2023%2F09%2Fhow-it-works-hevc-safari.mp4%22%20%0A%20%20%20%20type%3D'video%2Fmp4%3B%20codecs%3D%22hvc1%22'%3E%0A%20%20%3Csource%20%0A%20%20%20%20src%3D%22https%3A%2F%2Fliv.rent%2Fblog%2Fwp-content%2Fuploads%2F2023%2F09%2Fhow-it-works-vp9-chrome.webm%22%20%0A%20%20%20%20type%3D%22video%2Fwebm%22%3E%0A%3C%2Fvideo%3E"
                />
              </_Builtin.BlockContainer>
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.Block>
      </_Builtin.Container>
    </_Component>
  );
}
